<template>
  <div>
    <!-- 取消装箱 -->
    <el-dialog :title="$t('message.unpack')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1380px"
      center>
      <div class="content">
        <!-- 当前箱号 -->
        <div class="boxNum">
          {{ $t("message.presentBoxNum") }}: <span>{{ boxDetail.box_no }}</span>
        </div>
        <div class="table">
          <ol>

            <li class="flex05">
              NO
            </li>
            <li class="flex05">

            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 交易号/物流号 -->
            <li class="flex2">{{ $t("message.transactionNumberLogisticsNumber") }}</li>
            <!--本箱装货数  -->
            <li>{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 取出数量 -->
            <li class="flex25">{{ $t("message.takeOutQuantity") }}</li>
          </ol>
          <ul v-for="(item, index) in boxDetail.list" :key="index">
            <li class="flex05">
              {{ index + 1 }}
            </li>
            <li class="flex05">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>
                  <el-link :href="'/#/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" type="primary">{{
                    item.order_sn
                  }}</el-link>
                </p>
              </div>
            </li>
            <!--  番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="item.link.goods_url" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 交易号/物流号 -->
            <li class="flex2">
              <div>
                <div class="template" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                  <p>JY:{{ purchase.purchase_no }}</p>
                  <p v-for="(express_no, express_index) in purchase
                    .express_no" :key="express_index">
                    WL{{ express_index + 1 }}：{{ express_no }}
                  </p>
                </div>
              </div>

            </li>
            <!--本箱装货数  -->
            <li>
              {{ item.this_box_total_num }}
            </li>
            <!--取出数量  -->
            <li class="flex25">
              <div class="template">
                <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                  <span>
                    JY{{ purchaseIndex + 1 }}:
                    {{ purchase.purchase_no }}
                  </span>
                  <!-- 取消装箱数 -->
                  <span>
                    <el-input v-model="purchase.box_num" onfocus="this.select()"
                      @input="maxNum(item.this_box_total_num, index, purchaseIndex)"
                      onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" size="small"></el-input>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 取消装箱 -->
        <el-button type="primary" @click="unpack">
          {{ $t("message.unpack") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 仓库 -->
    <!-- <warehouse :type="8" :shelf_type_set="[1, 2, 3, 4]" :cancelEncasementData="cancelEncasementData" /> -->
  </div>
</template>
<script>
import warehouse from "@/components/common/warehouse";
export default {
  data() {
    return {
      dialogVisible: false,
      warehouseDialogVisible: false, //仓库
      cancelEncasementData: {}, //取消装箱数据
      checked: false,
      boxDetail: {},
      box_id: '',
      move_sn: '',
    };
  },
  computed: {

  },
  components: {
    warehouse,
  },
  methods: {
    // 获取箱子详情
    getBoxDetail() {
      let datas = {
        box_id: this.box_id,
      }
      this.$api.inventoryTransferApi.boxDetail(datas).then((res) => {
        res.data.list.forEach((item) => {
          item.checked = false
        })
        this.boxDetail = res.data
      });
    },
    //取出装箱数最大数
    maxNum(this_box_total_num, index, purchaseIndex) {
      let list =
        this.boxDetail.list[index].list
      let box_num = 0
      list.forEach((item) => {
        box_num += item.box_num
      })
      if (box_num > this_box_total_num) {
        this.$message.error("取出数量不能大于本箱装货数");
        list.forEach((item) => {
          item.box_num = 0
        })
        this.$forceUpdate();
      }
    },
    // 取消装箱
    unpack() {
      let datas = {
        box_id: this.box_id,
        target_grid_number: "",
        list: [],
      };
      //   取出数据
      this.boxDetail.list.forEach((item) => {
        if (item.checked) {
          item.list.forEach((items) => {
            datas.list.push({
              order_purchase_id: items.order_purchase_id,
              num: items.box_num,
            });
          });
        }
      });
      if (datas.list == false) return this.$message.error('未选择要取消装箱的商品')
      this.$api.inventoryTransferApi.outBox(datas).then((res) => {
        this.$message.success(res.msg);
        this.takeOutSucess();
      });
      // this.warehouseDialogVisible = true;
    },

    // 取出箱子成功
    takeOutSucess() {
      this.dialogVisible = false;
      this.warehouseDialogVisible = false;
      this.$store.dispatch("moveDetail", { move_sn: this.move_sn, });
      this.$store.dispatch("transferOrdeBoxList", { move_sn: this.move_sn, });
      this.$parent.checked = false
      this.$parent.handleCheckedChange()
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    margin-bottom: 24px;

    span {
      font-weight: bold;
    }
  }

  .table {

    ol {
      height: 50px;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .flex25 {
      flex: 2.5;
    }

    .row {
      display: flex;
      margin-bottom: 6px;
      line-height: 32px;
      background-color: #F6F6F6;
      padding: 6px;
      border-radius: 4px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}
</style>